<!--消防清单-->
<template>
  <div>
    <div id="formHtml" style="padding:30px 30px;">
      <div style="background:#1c1c1c;">
      <table cellspacing="1" cellpadding="0" width="100%" >
        <tr>
          <td  colspan="4" style="height:80px;"><span style="font-size:20px;">消防器材清单</span></td>
        </tr>
        <tr>
          <td>序号</td>
          <td width="220">类型</td>
          <td>数量</td>
          <td>有效期截至时间</td>
        </tr>
        <tr v-for="(obj, index) in form.list">
          <td  style="width:65px;">{{index+1}}</td>
          <td>
            <div v-if="obj.equipmentType!=null" v-text="obj.equipmentType"></div>
            <el-select v-else v-model="obj.equipmentType" placeholder="请选择">
              <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td style="text-align:center;align-items: center;"><input v-model="obj.equipmentCount" type="text" :class="edit(obj.equipmentCount)"/></td>
          <td>
            <!--<input v-model="obj.endTime" type="text" :class="edit(obj.endTime)"/>-->

            <el-date-picker
                    v-model="obj.validEndTime"
                    type="date"
                    placeholder="选择日期">
            </el-date-picker>
          </td>
        </tr>
      </table>
    </div>
    </div>
    <div style="padding:30px 30px;">
    <el-button size="small" type="success" @click="addRow">添加</el-button>
    </div>
    <div  class="dialog-footer" style="margin-top:10px;text-align: center;">
      <el-button @click="closeDialog()"  size="small">取 消</el-button>
      <el-button  size="small" type="primary" v-if="!prop.preview" @click="create('form')">保存</el-button>
    </div>
    <a id="download" v-show="false"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as html2canvas from "html2canvas";
import {addObj, getObj, putObj} from "../../../api/admin/sysFormFireControl/index";
export default {
  name: 'oilRegisterForm',
  props: ["formId", "prop"],
  data() {
    return {
      form: {
          formId:null,
          list:[{equipmentType:null,equipmentCount:null,validEndTime:null}]
      },
      types:[
      {value:"灭火器", label:"灭火器"},
      {value:"其他", label:"其他"},
      ]
    }
  },
  created() {
      this.init();
  },
  computed: {
    ...mapGetters([
      'elements'
    ])
  },
  methods: {
    init: function () {
        if(this.formId){
            getObj(this.formId).then(response=>{
                this.form=response;
            })
        }
    },
    html(callback) {
        html2canvas(document.querySelector("#formHtml"), {scale: 2}).then(canvas => {
            callback && callback(canvas);
        })
    },
    download(fileName){
        this.html((canvas)=>{
            fileName += ".png";
            if (window.navigator.msSaveBlob) {
                var blob = canvas.msToBlob()
                window.navigator.msSaveBlob(blob, fileName)
            } else {
                var url = canvas.toDataURL()     //把canvas转成base64
                // 写一个隐藏的按标签，借助按标签的download属性下载图片
                document.querySelector('#download').href = url;
                document.querySelector('#download').download = fileName;
                document.querySelector('#download').click()
            }
        });
    },
    create() {
        this.editStatus = false;
        this.$nextTick(()=>{
            addObj(this.form).then((response) => {
                this.html(canvas=>{
                    this.$emit("on-success", {...response, content: canvas.toDataURL()});
                })
            })
        })
    },
    addRow:function(){
      let obj = {...this.form.list[0]}
      Object.keys(obj).forEach(x=>{
        obj[x] = null;
      })
      this.form.list.push(obj);
    },
    edit:function(val){
      if(val && String.valueOf(val).length>0 || this.prop.preview){
        return "edit";
      }
      return "";
    },
    closeDialog(){
      this.$emit('close')
    }
  }
}
</script>
<style>
  table td .el-input__inner{ border:none;}
</style>
<style scoped>
table td {background:#FFF;padding:0px 4px;height:40px;box-sizing:border-box;text-align:center;}
table td .checkbox{width:16px;height:16px;border:solid 1px #000;background:#FFF;position:relative;top:3px;}
table td input{background:url(./img/edit.png) 10px no-repeat;width:100%;height:100%;border:none;text-indent:0px;border:none;font-size:14px;outline:none;padding-left:10px;box-sizing: border-box;}
table td .shortInput{ width:60px;height:100%;border:none;}
table td .longInput{ width:290px;height:100%;border:none;}
.edit{background:transparent;}
</style>